import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import * as promise from 'redux-promise-middleware';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import rootReducer from './redux/reducers/index.jsx';
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist"
import { activeFeature } from './helpers/constant.js';


const persistConfig = {
    key: "root",
    storage,
    whitelist: ['authStore']
}

const persistedReducer = persistReducer(persistConfig, rootReducer);

function logger({ getState }) {
  return (next) => (action) => {
    if (activeFeature.REDUX_LOGGER) {
      console.log('will dispatch', action)
    }

    // Call the next dispatch method in the middleware chain.
    const returnValue = next(action);

    if (activeFeature.REDUX_LOGGER) {
      console.log('state after dispatch', getState())
    }

    // This will likely be the action itself, unless
    // a middleware further in chain changed it.
    return returnValue;
  };
}

const middleware = composeWithDevTools(applyMiddleware(promise.default, thunk, logger));

export default createStore(persistedReducer, middleware);